import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { TuiButtonModule, TuiDialogContext, TuiDialogModule, TuiErrorModule } from '@taiga-ui/core';
import { TuiFieldErrorPipeModule, TuiInputNumberModule } from '@taiga-ui/kit';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';
import { CartActions } from '@us/web/cart/data-access';
import { Table } from '@us/web/shared/data-access';
import { cloneDeep } from 'lodash';

@UntilDestroy()
@Component({
    selector: 'us-cart-number-guest',
    templateUrl: './cart-table-number-guest.component.html',
    styleUrls: ['./cart-table-number-guest.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        TranslocoModule,
        CommonModule,
        TuiDialogModule,
        TuiButtonModule,
        TuiInputNumberModule,
        FormsModule,
        ReactiveFormsModule,
        TuiErrorModule,
        TuiFieldErrorPipeModule
    ]
})
export class CartTableNumberGuestComponent {
    private readonly context = inject(POLYMORPHEUS_CONTEXT) as TuiDialogContext<void, { table: Table }>;
    private readonly store = inject(Store);

    private readonly table: Table = cloneDeep(this.context.data.table);
    otherFlg = false;
    readonly amountCtrl = new FormControl(0, [Validators.min(1), Validators.required]);
    readonly items: number[] = Array.from({ length: 16 }, (_, i) => i + 1);

    handleSubmit(amount = 0) {
        if (amount) {
            this.amountCtrl.patchValue(amount);
        }
        this.amountCtrl.markAllAsTouched();
        this.amountCtrl.updateValueAndValidity();
        if (this.amountCtrl.invalid) {
            return;
        }
        if (this.table) {
            this.store.dispatch(
                CartActions.updateCart({
                    order_table: {
                        ...this.table,
                        amount_of_people: this.amountCtrl.value ?? 0
                    }
                })
            );
            this.context.completeWith();
        }
    }
}
